import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Chevron Left With Line Stroke
 */

export default function ChevronLeftLineStrokeIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <path
        clipRule="evenodd"
        d="M10.8536 2.13518C11.0488 2.31542 11.0488 2.60765 10.8536 2.7879L5.20711 8L10.8536 13.2121C11.0488 13.3923 11.0488 13.6846 10.8536 13.8648C10.6583 14.0451 10.3417 14.0451 10.1464 13.8648L4.14645 8.32636C3.95118 8.14612 3.95118 7.85389 4.14645 7.67364L10.1464 2.13518C10.3417 1.95494 10.6583 1.95494 10.8536 2.13518Z"
        fill="black"
        fillRule="evenodd"
      />
      <line stroke="black" x1="1.5" x2="1.5" y1="2" y2="14" />
    </Icon>
  );
}
